import styled from 'styled-components';

export const Wrapper = styled.div`
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  overflow-x: hidden;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const Container = styled.section`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 100%;
  flex: 1 1 auto;
  height: 100%;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
`;
